import { Text as PDFText, View } from "@react-pdf/renderer";
import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";
import type { PropsWithChildren } from "react";
import React from "react";
import { tw } from "./tailwind";
import type { ClassNameProps, Style } from "./types";

/** Props Interface */
interface TextProps extends PropsWithChildren, VariantProps<typeof text>, ClassNameProps {
	style?: Style;
	maxLines?: number;
	fixed?: boolean;
	debug?: boolean;
	monospace?: boolean;
}

export function Text({
	children,
	style,
	maxLines,
	size,
	debug,
	className = "",
	monospace,
}: TextProps) {
	/** Classes */
	const classes = text({ size });

	const textOverflow = maxLines ? "ellipsis" : undefined;

	/** Render */
	return (
		<React.Fragment>
			<View>
				<PDFText
					debug={debug}
					style={{
						...tw("text-justify"),
						...tw(clsx(classes, className)),
						maxLines,
						textOverflow,
						...(style as object),
						fontFamily: monospace ? "Mono" : "Sans",
					}}
				>
					{children}
				</PDFText>
			</View>
		</React.Fragment>
	);
}

const text = cva([], {
	variants: {
		size: {
			sm: "text-sm",
			md: "text-base",
			lg: "text-lg",
			xl: "text-xl",
		},
	},
	defaultVariants: {
		size: "sm",
	},
});
